import React, {useContext} from "react";
import Style from "./bankTransferMobile.module.scss";
import { useTranslation } from "react-i18next";
import {CountryCode} from "../reducers/ticket";
import {
    beppoCompanies,
    prepareGiroCodeData
} from "../reusable/functions";
import QRCode from "react-qr-code";
import QRLogo from "../common/assets/qrLogo.png";
import GenericMobileCard from "./general/genericMobileCard";
import {TicketDetailsContext} from "./TicketDetailsContext";
import {formatCurrency} from "../util/formatter";

const BankTransferMobile = () => {
  const { t } = useTranslation();
  const {
    formattedAmountLabel,
    ticket,
    market: countryCode
  } = useContext(TicketDetailsContext);

  if (!ticket) {
    // early return when no ticket
    return null;
  }

  const {
      iban,
      ibanText,
      ibanSocar,
      ibanSocarText,
      businessName,
      streetName,
      streetNumber,
      postalCode,
      townName,
      country,
      bic,
      bank
  } = beppoCompanies[countryCode];

  const totalAmount =
          ticket.gasStationZone != null
              ? (ticket.totalGasStationAmount - ticket?.paidAmount)
              : ticket.status === "PAID"
                  ? ticket.paidAmount
                      ? 0
                      : ticket?.amount
                  : ticket?.reminderDeadline
                      ? (
                          ticket?.amount +
                          ticket?.reminderFee +
                          ticket?.additionalCost -
                          ticket?.paidAmount
                      )
                      : (ticket?.amount - ticket?.paidAmount);

  const ibanInQR = ticket.parkingZone != null ? iban : ibanSocar;

  const giroCode = prepareGiroCodeData(bic, businessName, ibanInQR, "EUR", formatCurrency(totalAmount, countryCode), ticket.number);


  const qrValue =
    countryCode !== CountryCode.CH
        ? giroCode
        :
    "SPC\n" +
    "0200\n" +
    "1\n" +
    ibanInQR +
    "\n" +
    "S\n" +
    businessName +
    "\n" +
    streetName +
    "\n" +
    streetNumber +
    "\n" +
    postalCode +
    "\n" +
    townName +
    "\n" +
    country +
    "\n" +
    "\n" +
    "\n" +
    "\n" +
    "\n" +
    "\n" +
    "\n" +
    "\n" +
    formatCurrency(totalAmount, countryCode) +
    "\n" +
    "CHF\n" +
    "\n" +
    "\n" +
    "\n" +
    "\n" +
    "\n" +
    "\n" +
    "\n" +
    "NON\n" +
    "\n" +
    ticket.number +
    "\n" +
    "EPD\n";

  return (
    <GenericMobileCard title={t("TicketDetails.BankTransfer").toString()}>
      <div className={Style.qrContainer}>
        <div className={Style.qrContainer__title}>
          {t("TicketDetails.QR title").toString()}
        </div>
        <div className={Style.qrContainer__box}>
          {countryCode === CountryCode.CH && <img src={QRLogo} alt="qrLogo" className={Style.qrContainer__icon} />}
          <QRCode value={qrValue} size={150} />
        </div>
      </div>
      <div className={Style.detailsContainer}>
        <div className={Style.detailsContainer__heading}>
          {t("TicketDetails.Account details").toString()}
        </div>
        <div style={{ marginTop: "10px" }}>
          <div className={Style.detailsContainer__paragraphMobile}>
            <span>{t("TicketDetails.Account owner").toString()}</span>
            <div className={Style.detailsContainer__horizontalLine}></div>
            <span className={Style.detailsContainer__paragraphBold}>
              {businessName}
            </span>
          </div>
          <div className={Style.detailsContainer__paragraphMobile}>
            <span>IBAN</span>
            <div className={Style.detailsContainer__horizontalLine}></div>
            <span className={Style.detailsContainer__paragraphBold}>
              {ticket.parkingZone != null ? ibanText : ibanSocarText}
            </span>
          </div>
          <div className={Style.detailsContainer__paragraphMobile}>
            <span>BIC</span>
            <div className={Style.detailsContainer__horizontalLine}></div>
            <span className={Style.detailsContainer__paragraphBold}>{bic}</span>
          </div>
          <div className={Style.detailsContainer__paragraphMobile}>
            <span>{t("TicketDetails.Financial institution").toString()}</span>
            <div className={Style.detailsContainer__horizontalLine}></div>
            <span className={Style.detailsContainer__paragraphBold}>
              {bank}
            </span>
          </div>
          <div className={Style.detailsContainer__paragraphMobile}>
            <span>{formattedAmountLabel}</span>
            <div className={Style.detailsContainer__horizontalLine}></div>
            <span className={Style.detailsContainer__paragraphBold}>
              {formatCurrency(totalAmount, countryCode)}
            </span>
          </div>
          <div className={Style.detailsContainer__paragraphMobile}>
            <span style={{ color: "#CC0605" }}>
              {t("TicketDetails.Additional information mobile").toString()}
            </span>
            <div className={Style.detailsContainer__horizontalLine}></div>
            <span
              className={Style.detailsContainer__paragraphBold}
              style={{ color: "#CC0605" }}
            >
              {ticket.number}
            </span>
          </div>
        </div>
      </div>
    </GenericMobileCard>
  );
};

export default BankTransferMobile;
